'use strict'

import pictureFill from 'picturefill';
import helpers from './lib/helpers.js';

const _BPMD     = 767;
const _BPLG     = 1023;

$("#owl-carousel").owlCarousel({
	autoPlay: 8000,
	navigation : true, 
	slideSpeed : 500,
	paginationSpeed : 600,
	singleItem:true,
	navigationText: ["<span class='i-car-prev'></span>","<span class='i-car-next'></span>"]
});

if(helpers.getCookie('mw-blog-grid') === 'false') {
    $('.o-post-tile__nav__toggler > a').removeClass('is-active');
	$(this).addClass('is-active');
	$('.o-post-tiles').removeClass('is-grid');
}
 
$('.o-post-tile__nav__toggler .is-grid').click(function(){
	$('.o-post-tile__nav__toggler > a').removeClass('is-active');
	$(this).addClass('is-active');
 	$('.o-post-tiles').addClass('is-grid');
    helpers.setCookie('mw-blog-grid', 'true', 1);
});

$('.o-post-tile__nav__toggler .is-list').click(function(){
	$('.o-post-tile__nav__toggler > a').removeClass('is-active');
	$(this).addClass('is-active');
	$('.o-post-tiles').removeClass('is-grid');
    helpers.setCookie('mw-blog-grid', 'false', 1);
});

$('.j-toggle-shop-menu').click(function(){
	$('.t-darkness').toggle();
	$('.j-shop-menu').toggle();
});

$('.j-toggle-main-menu').click(function(){
	$('.t-darkness').toggle();
	$('.j-main-menu').toggle();
});

$('.j-toggle-search').click(function(){
	$('.c-search-screen').fadeToggle(400);
});

$('.t-darkness').click(function(){
	$('.t-darkness').hide();
	$('.o-side-menu').hide();
	$('.o-side-menu--main').hide();
});


$('.o-side-menu__main a').click(function (e) {
    if ($(window).outerWidth() < _BPMD) {
        if($(this).next('ul').children().length > 0) {
            // $(this).toggleClass('is-active');
            $(this).next('ul').toggle();
            return false;
        }
    }
});


{
    let menuTimeout = null;

    $('#menu-main-menu > li').bind('mouseenter', function() {
        if ($(window).outerWidth() >= _BPMD) {
            let menu = this;

            clearTimeout(menuTimeout);

            menuTimeout = setTimeout(function() {
                $(menu).find('ul.sub-menu').show();
            }, 200);

            $(menu).bind('mouseleave', function() {
                clearTimeout(menuTimeout);
                $(menu).find('ul.sub-menu').hide();
            });
        }
    });
};


// WEBPACK FOOTER //
// ./content/js/app.js